

$(document).ready(function () {
    if ($(window).width() > 1025 ){
  $('.menu__panel.menu__list.menu__level-01.d-flex.flex-column.flex-lg-row.flex-lg-wrap > .menu__item.menu__item--has-children > a').attr('aria-expanded', 'false');

  // Initialize dropdown toggle functionality
  $('.menu__item--has-children > a.d-flex').not('.menu__title').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const $parentItem = $(this).closest('.menu__item--has-children');
      const $megamenu = $parentItem.find('.menu__megamenu.d-lg-none.position-lg-absolute');
      const $dropdown = $parentItem.find('.menu__dropdown.d-lg-none.position-lg-absolute');
      const isOpen = $parentItem.hasClass('is-open');

      // Close all open dropdowns first
      $('.menu__item--has-children.is-open').each(function () {
          const $otherMegamenu = $(this).find('.menu__megamenu.d-lg-none.position-lg-absolute');
          const $otherDropdown = $(this).find('.menu__dropdown.d-lg-none.position-lg-absolute');
          $otherMegamenu.removeClass('show animate visible').slideUp(300);
          $otherDropdown.removeClass('show animate visible').slideUp(300);
          $(this).removeClass('is-open').find('> a').attr('aria-expanded', 'false');
      });

      // Toggle the current dropdown
      if (isOpen) {
          $megamenu.removeClass('show animate visible').css('height', '').slideUp(300);
          $dropdown.removeClass('show animate visible').slideUp(300);
          $parentItem.removeClass('is-open');
          $(this).attr('aria-expanded', 'false');
      } else {
          $megamenu.addClass('show animate visible').css('height', '453px').slideDown(300);
          $dropdown.addClass('show animate visible').slideDown(300);
          $parentItem.addClass('is-open');
          $(this).attr('aria-expanded', 'true');
      }
  });

  // Close all open dropdowns when clicking outside
  $(document).on('click', function (e) {
      if (!$(e.target).closest('.menu__item--has-children').length) {
          $('.menu__item--has-children.is-open').each(function () {
              const $megamenu = $(this).find('.menu__megamenu.d-lg-none.position-lg-absolute');
              const $dropdown = $(this).find('.menu__dropdown.d-lg-none.position-lg-absolute');
              $megamenu.removeClass('show animate visible').slideUp(300);
              $dropdown.removeClass('show animate visible').slideUp(300);
              $(this).removeClass('is-open').find('> a').attr('aria-expanded', 'false');
          });
      }
  });

  // Close all open dropdowns when pressing Escape
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') {
        $('.menu__item--has-children.is-open').each(function () {
            const $megamenu = $(this).find('.menu__megamenu.d-lg-none.position-lg-absolute');
            const $dropdown = $(this).find('.menu__dropdown.d-lg-none.position-lg-absolute');
            $megamenu.removeClass('show animate visible').slideUp(300);
            $dropdown.removeClass('show animate visible').slideUp(300);
            $(this).removeClass('is-open').find('> a').attr('aria-expanded', 'false');
        });
    }
  });

  // Close menu when focus goes to the specific links
  $('a[href="/pages/soy-sauce"]').on('focus', function () {
      $('.menu__item--has-children.is-open').each(function () {
          const $megamenu = $(this).find('.menu__megamenu.d-lg-none.position-lg-absolute');
          const $dropdown = $(this).find('.menu__dropdown.d-lg-none.position-lg-absolute');
          $megamenu.removeClass('show animate visible').slideUp(300);
          $dropdown.removeClass('show animate visible').slideUp(300);
          $(this).removeClass('is-open').find('> a').attr('aria-expanded', 'false');
      });
  });
    }
});


//End


// $(document).ready(function () {
//   var existCondition = setInterval(function () {
//       if ($('img[src="https://cdn.shopify.com/s/files/1/0719/4237/3621/files/image_4.jpg?v=1728369399"]').length) {
//           clearInterval(existCondition);
//           runMyFunctionalt();
//       }
//   }, 200);

//   function runMyFunctionalt() {
//     $('img[src="https://cdn.shopify.com/s/files/1/0719/4237/3621/files/image_4.jpg?v=1728369399"]').attr('alt', 'A gloved hand is spreading smoked paprika on a metal tray');
//   }
// });

// $(document).ready(function () {
//   var existCondition = setInterval(function () {
//       if ($('img[src="https://cdn.shopify.com/s/files/1/0719/4237/3621/files/image_1.jpg?v=1728363636"]').length) {
//           clearInterval(existCondition);
//           runMyFunctionalt2();
//       }
//   }, 200);

//   function runMyFunctionalt2() {
//     $('img[src="https://cdn.shopify.com/s/files/1/0719/4237/3621/files/image_1.jpg?v=1728363636"]').attr('alt', 'A man wearing gloves for food safety is holding a tray and raking a soybean and wheat mixture into a barrel as part of the soy sauce process');
//   }
// });

// $(document).ready(function () {
//   var existCondition = setInterval(function () {
//       if ($('img[src="https://cdn.shopify.com/s/files/1/0719/4237/3621/files/image_5.jpg?v=1728369399"]').length) {
//           clearInterval(existCondition);
//           runMyFunctionalt3();
//       }
//   }, 200);

//   function runMyFunctionalt3() {
//     $('img[src="https://cdn.shopify.com/s/files/1/0719/4237/3621/files/image_5.jpg?v=1728369399"]').attr('alt', 'A view into the old Bourbon Barrel Foods store on Frankfort Avenue');
//   }
// });

// $(document).ready(function () {
//   var existCondition = setInterval(function () {
//       if ($('img[src="https://cdn.shopify.com/s/files/1/0719/4237/3621/files/image_3.jpg?v=1728369399"]').length) {
//           clearInterval(existCondition);
//           runMyFunctionalt4();
//       }
//   }, 200);

//   function runMyFunctionalt4() {
//     $('img[src="https://cdn.shopify.com/s/files/1/0719/4237/3621/files/image_3.jpg?v=1728369399"]').attr('alt', 'Matt Jamie in Japan with fifth-generation soy sauce brewer, Toshio Shinko');
//   }
// });

// $(document).ready(function () {
//   var existCondition = setInterval(function () {
//       if ($('img[src="https://cdn.shopify.com/s/files/1/0719/4237/3621/files/image_2.jpg?v=1728369399"]').length) {
//           clearInterval(existCondition);
//           runMyFunctionalt5();
//       }
//   }, 200);

//   function runMyFunctionalt5() {
//     $('img[src="https://cdn.shopify.com/s/files/1/0719/4237/3621/files/image_2.jpg?v=1728369399"]').attr('alt', 'Matt Jamie sitting at the bar at Bourbon Barrel Foods');
//   }
// });

// //Our Story page

// $(document).ready(function () {
//   var existCondition = setInterval(function () {
//       if ($('img[src="https://cdn.shopify.com/s/files/1/0719/4237/3621/files/3_1.jpg?v=1730097204"]').length) {
//           clearInterval(existCondition);
//           runMyFunctionalt6();
//       }
//   }, 200);

//   function runMyFunctionalt6() {
//     $('img[src="https://cdn.shopify.com/s/files/1/0719/4237/3621/files/3_1.jpg?v=1730097204"]').attr('alt', 'Matt Jamie leading a tour at Bourbon Barrel Foods and demonstrating the industrial smokers used to smoke Spices');
//   }

  
//   var existCondition2 = setInterval(function () {
//       if ($('img[src="https://cdn.shopify.com/s/files/1/0719/4237/3621/files/1_1.jpg?v=1730097204"]').length) {
//           clearInterval(existCondition2);
//           runMyFunctionalt7();
//       }
//   }, 200);

//   function runMyFunctionalt7() {
//     $('img[src="https://cdn.shopify.com/s/files/1/0719/4237/3621/files/1_1.jpg?v=1730097204"]').attr('alt', 'A warm stylized photo of Bluegrass Soy Sauce on a wooden table');
//   }

//   var existCondition3 = setInterval(function () {
//       if ($('img[src="https://cdn.shopify.com/s/files/1/0719/4237/3621/files/4_1.jpg?v=1730097204"]').length) {
//           clearInterval(existCondition3);
//           runMyFunctionalt8();
//       }
//   }, 200);

//   function runMyFunctionalt8() {
//     $('img[src="https://cdn.shopify.com/s/files/1/0719/4237/3621/files/4_1.jpg?v=1730097204"]').attr('alt', 'Matt Jamie leading a tour at Bourbon Barrel Foods ');
//   }

//   var existCondition4 = setInterval(function () {
//       if ($('img[src="https://cdn.shopify.com/s/files/1/0719/4237/3621/files/5_1.jpg?v=1730097204"]').length) {
//           clearInterval(existCondition4);
//           runMyFunctionalt9();
//       }
//   }, 200);

//   function runMyFunctionalt9() {
//     $('img[src="https://cdn.shopify.com/s/files/1/0719/4237/3621/files/5_1.jpg?v=1730097204"]').attr('alt', 'Matt Jamie sitting at the bar at Bourbon Barrel Foods');
//   }

//   var existCondition5 = setInterval(function () {
//       if ($('img[src="https://cdn.shopify.com/s/files/1/0719/4237/3621/files/2_1.jpg?v=1730097204"]').length) {
//           clearInterval(existCondition5);
//           runMyFunctionalt10();
//       }
//   }, 200);

//   function runMyFunctionalt10() {
//     $('img[src="https://cdn.shopify.com/s/files/1/0719/4237/3621/files/2_1.jpg?v=1730097204"]').attr('alt', 'A wide angle shot of Bourbon Barrel Foods bar and tasting  Counter');
//   }

// });

$(document).ready(function(){
    // Parent menu links keep their href (so they stay focusable); the click
    // handler above intercepts activation to toggle the submenu instead.
    $('svg.loo-icon').attr('aria-hidden','true');
  });

  // $(document).ready(function () {
  //   var existCondition = setInterval(function () {
  //       if ($('.ticker.gradient ticker-section').length) {
  //           clearInterval(existCondition);
  //           runMyFunctionrmvtbani();
  //       }
  //   }, 200);
  
  //   function runMyFunctionrmvtbani() {
  //     $('.ticker.gradient ticker-section').removeClass();
  //   }
  // });

  $(document).ready(function () {
    $('h2.h4.mb-15.title').each(function () {
        if ($(this).text().trim() === '' && $(this).children().length === 0) {
            $(this).remove();
        }
    });
  });

$(document).ready(function () {
  $('h6').each(function () {
      if ($(this).text().trim() === '' && $(this).children().length === 0) {
          $(this).remove();
      }
  });
});

$(document).ready(function () {
  $('h3.h4.mb-15.title').each(function () {
      if ($(this).text().trim() === '' && $(this).children().length === 0) {
          $(this).remove();
      }
  });
});

$(document).ready(function () {
  $('h6 span').each(function () {
      if ($(this).text().trim() === '' && $(this).children().length === 0) {
          $(this).remove();
      }
  });
});

$(document).ready(function () {
  $('h6.small-title.mb-0').each(function () {
      if ($(this).text().trim() === '' && $(this).children().length === 0) {
          $(this).remove();
      }
  });
});

$(document).ready(function () {
  $('h2').each(function () {
      if ($(this).text().trim() === '' && $(this).children().length === 0) {
          $(this).remove();
      }
  });
});

$(document).ready(function () {
  $('h3 .h4.mb-15.title').each(function () {
      if ($(this).text().trim() === '' && $(this).children().length === 0) {
          $(this).remove();
      }
  });
});




$(document).ready(function () {
  let $carousel = $(".ada-cr-carousel");
  let $items = $(".ada-cr-carousel-item");
  let visibleImages = 6; // Number of images visible at a time
  let scrollStep = 2; // Number of images moved per scroll
  let itemWidth = $items.outerWidth(true);
  let moveAmount = scrollStep * itemWidth;
  let totalItems = $items.length;

  // Clone first few images and append to carousel for looping effect
  $items.slice(0, visibleImages).clone().appendTo($carousel);

  let totalSlides = $(".ada-cr-carousel-item").length;
  let maxScroll = (totalSlides - visibleImages) * itemWidth;

  function moveSlide(direction) {
      let currentLeft = parseInt($carousel.css("transform").split(",")[4]) || 0;

      if (direction === "next") {
          if (Math.abs(currentLeft) >= maxScroll) {
              // Instantly reset to the start without animation for looping effect
              $carousel.css("transition", "none");
              $carousel.css("transform", `translateX(0px)`);
              setTimeout(() => {
                  $carousel.css("transition", "transform 0.4s ease-in-out");
                  $carousel.css("transform", `translateX(-${moveAmount}px)`);
              }, 20);
          } else {
              $carousel.css("transform", `translateX(${currentLeft - moveAmount}px)`);
          }
      } else {
          if (currentLeft >= 0) {
              // Instantly reset to the end without animation for looping effect
              $carousel.css("transition", "none");
              $carousel.css("transform", `translateX(-${maxScroll}px)`);
              setTimeout(() => {
                  $carousel.css("transition", "transform 0.4s ease-in-out");
                  $carousel.css("transform", `translateX(${currentLeft + moveAmount}px)`);
              }, 20);
          } else {
              $carousel.css("transform", `translateX(${currentLeft + moveAmount}px)`);
          }
      }
  }


  
  $(".ada-cr-arrow-left").click(function () {
      moveSlide("prev");
  });

  $(".ada-cr-arrow-right").click(function () {
      moveSlide("next");
  });
});

$(document).ready(function () {
  var existCondition = setInterval(function () {
      if ($('#referral-share-email-to').length) {
          clearInterval(existCondition);
          runMyFunctionrmvtb1();
      }
  }, 200);

  function runMyFunctionrmvtb1() {
    $('#referral-share-email-to').attr('aria-label','Enter Email');
  }
});
$(document).ready(function () {
  $(document).on("keydown", function (event) {
      if (event.key === "Enter" || event.key === " " || event.key === "Spacebar") {
          let $activeElement = $(document.activeElement);

          if ($activeElement.is("[data-js-accordion-button]")) {
              event.preventDefault(); // Prevent default behavior

              let $content = $("#" + $activeElement.attr("aria-controls"));
              let isOpen = $activeElement.attr("aria-expanded") === "true";

              if (isOpen) {
                  $activeElement.attr("aria-expanded", "false").removeClass("open");
                  $content.addClass("d-none");
              } else {
                  $activeElement.attr("aria-expanded", "true").addClass("open");
                  $content.removeClass("d-none");
              }
          }
      }
  });
});
$(document).ready(function() {
  // Sold-out buttons stay real <button> elements; native disabled conveys state.
  $('button[data-button-status="sold-out"]').attr('disabled', 'disabled');
});

$(document).ready(function () {
  var existCondition = setInterval(function () {
      if ($('.logo-image-wrapper img').length) {
          clearInterval(existCondition);
          runMyFunctionrmvtb3();
      }
  }, 200);

  function runMyFunctionrmvtb3() {
    $('.logo-image-wrapper img').attr('alt','');
  }
});

// $(document).ready(function() {
//   var thirdPartyLinks = $('li.mr-0.mr-lg-25 a, footer a');

//   // Loop through each link
//   thirdPartyLinks.each(function() {
//       var link = $(this);
      
//       // Check if the link leads to a third-party website
//       if (isThirdParty(link.attr('href'))) {
//           // Add the target="_blank" attribute
//           link.attr('target', '_blank');

//           // Add the text indicating it will open in a new tab
//           var existingText = link.text().trim();
//           var newText = existingText + ', This Link will open in a new tab';
//           link.attr('aria-label', newText);
//       }
//   });

//   // Function to check if a link is from a third-party website
//   function isThirdParty(url) {
//       return !url.includes('bourbonbarrelfoods.com');
//   }
// });

// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function() {
  scrollFunction();
};

function scrollFunction() {
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
    document.getElementById("back-to-top").style.display = "block";
  } else {
    document.getElementById("back-to-top").style.display = "none";
  }
}

// When the user clicks on the button, scroll to the top of the document
document.getElementById("back-to-top").onclick = function() {
  scrollToTop();
};

function scrollToTop() {
  const scrollStep = -window.scrollY / (500 / 1000);
  const scrollInterval = setInterval(function() {
    if (window.scrollY !== 0) {
      window.scrollBy(0, scrollStep);
    } else {
      clearInterval(scrollInterval);
    }
  }, 15);
}



$(document).ready(function () {
  // Function to check if the screen is desktop or laptop size
  function isDesktop() {
    return window.matchMedia('(min-width: 1024px)').matches; // Adjust breakpoint as needed
  }

  // The native #SortByClone <select> is fully keyboard- and screen-reader-
  // accessible; the former div-based replacement dropdown was not, so it
  // has been removed and the native control is used on all viewports.
});

// Ecom20
// $(document).ready(function() {
//   var $searchButton = $('.header__btn-search');
//   var $closeButton = $('.search__close');
//   $closeButton.on('click', function() {
//     setTimeout(function() {
//       $searchButton.focus();
//     }, 300); 
//   });
//   $(document).on('keydown', function(e) {
//     if (e.key === "Escape") {
//       if ($closeButton.is(':visible')) {
//         $closeButton.trigger('click'); 
//       } else {
//         $searchButton.focus(); 
//       }
//     }
//   });
// });
$(document).ready(function() {
  const $searchButton = $('.header__btn-search');
  const $searchPopup = $('.popup-navigation__search');
  const $closeButton = $searchPopup.find('.search__close');
  const $searchInput = $searchPopup.find('#Search');

  $searchButton.on('click', function() {
    setTimeout(function() {
      $searchPopup.show();
      $searchInput.focus();
    }, 300);
  });

  $closeButton.on('click', function() {
    $searchPopup.hide();
    $searchButton.focus();
  });

  $(document).on('keydown', function(event) {
    if (event.key === 'Escape' && $searchPopup.is(':visible')) {
      $searchPopup.hide();
      $searchButton.focus();
    }
  });
});

// for wishlist
$(document).ready(function() {
  var wishlistBtn = $('.header__btn-wishlist');
  var closeBtn = $('.popup-wishlist__close');

  closeBtn.on('click', function() {
      wishlistBtn.focus();  
  });
});




// for filter collapsed
$(document).ready(function() {
  $('#filter-dropdown-click label').on('click', function() {
    let isExpanded = $(this).attr('aria-expanded') === 'true';
    $(this).attr('aria-expanded', !isExpanded);
  });
});

// for excape
// $(document).on('keydown', function(e) {
//   if (e.key === 'Escape') {
//       $('#filter-dropdown-click').attr('aria-expanded', 'false');
//       $('.select__dropdown').removeClass('show animate visible').addClass('d-none');
//   }

// });

// this is for add to cart
$(document).ready(function () {
  var $cartButton = $(".js-popup-button[data-js-popup-button='cart']");
  var $cartPopup = $(".popup-cart.js-popup-cart-ajax");
  var $closeButton = $(".popup-cart__close");
  $cartButton.on("click", function (e) {
      e.preventDefault();
      setTimeout(function () {
          $cartPopup.attr("tabindex", "-1").focus();
      }, 100); 
  });
  $closeButton.on("click", function () {
      setTimeout(function () {
          $cartButton.focus();
      }, 100);
  });
});


// Keep tab/accordion ARIA state in sync after the theme's tab JS runs
$(document).ready(function () {
  $(document).on("click", "[data-js-tabs-btn], [data-js-tabs-btn-mobile]", function () {
    setTimeout(function () {
      $("[data-js-tabs-btn-mobile]").each(function () {
        $(this).attr("aria-expanded", $(this).closest("[data-js-tabs-tab]").hasClass("active") ? "true" : "false");
      });
    }, 50);
  });
});

// Keep variant swatch pressed-state in sync (delegated so AJAX content works)
$(document).ready(function () {
  $(document).on("click", ".product-options__value", function () {
    var $section = $(this).closest(".product-options__section");
    $section.find(".product-options__value").attr("aria-pressed", "false").find(".sr-only").remove();
    $(this).attr("aria-pressed", "true").append('<span class="sr-only">selected</span>');
  });
});

$(function () {
  $(" .button-wrapper").each(function () {
    $(this).find(".btn-text").attr("aria-label", "Continue Reading about " + $(this).siblings(".title").find("a").text().trim());
  });
});

// // this is tab panel code 
// document.addEventListener("DOMContentLoaded", function() {
//   const tabs = document.querySelectorAll('[data-js-tabs-tab]');
  
//   tabs.forEach(tab => {
//       const button = tab.querySelector('.tab-region');
//       const content = tab.querySelector('.tabs__content');

//       // Set initial aria-expanded attribute
//       button.setAttribute('aria-expanded', 'false');

//       button.addEventListener('click', function() {
//           // Toggle the content display
//           if (content.style.display === 'none' || content.style.display === '') {
//               content.style.display = 'block'; // Show the content
//               button.setAttribute('aria-expanded', 'true'); // Set aria-expanded to true
//           } else {
//               content.style.display = 'none'; // Hide the content
//               button.setAttribute('aria-expanded', 'false'); // Set aria-expanded to false
//           }
//       });
//   });
// });

//  this is for location Vi
 $('br').attr('aria-hidden', 'true');
// this is for external warning
 $(document).ready(function() {
  $('a[href="https://www.exploretock.com/bourbon-barrel-foods/"]').each(function() {
      var originalTitle = $(this).text();
  

var trimmedTitle = originalTitle.length > 20 ? originalTitle.substring(0, 100) + '' : originalTitle;
  
    $(this).attr('aria-label', trimmedTitle + ' (this link will open in a new window)');
    
    $(this).attr('target', '_blank');
    $(this).removeAttr('title');});
});

// this is for warning
$(document).ready(function() {
  $('a[href="mailto:emily@bourbonbarrelfoods.com."]').each(function() {
      var originalTitle = $(this).text();
      var trimmedTitle = originalTitle.length > 20 ? originalTitle.substring(0, 100) : originalTitle;
      
      $(this).attr('aria-label', 'Email Address: ' + trimmedTitle + ' (This link will open in a new tab)');
      
      $(this).attr('target', '_blank');
      $(this).removeAttr('title');
  });
});

$('br').attr('aria-hidden', 'true');

// faq 1st section
$(document).ready(function () {
  $('[data-js-accordion-button]').each(function () {
      var content = $(this).next('[data-js-accordion-content]');
      var attrs = {
          'aria-expanded': content.length && !content.hasClass('d-none') ? 'true' : 'false',
          'role': 'button',
          'tabindex': '0'
      };
      if (content.length) {
          var contentId = 'accordion-content-' + Math.random().toString(36).substr(2, 9);
          content.attr('id', contentId);
          attrs['aria-controls'] = contentId;
      }
      $(this).attr(attrs);
  });

  $('[data-js-accordion-button]').click(function () {
      var content = $(this).next('[data-js-accordion-content]');
      var isExpanded = $(this).attr('aria-expanded') === 'true';
      $(this).attr('aria-expanded', !isExpanded);
      content.toggleClass('d-none', isExpanded); 
  });
});


// for keep in touch popup
$(document).ready(function() {
  if ($('.popup-subscription').is(':visible')) {
    $('.popup-subscription__close').focus();
  }
  $(document).on('keydown', function(e) {
    if (e.key === "Escape") {
      $('.popup-subscription__close').click();
    }
  });
  $('.popup-subscription').on('transitionend', function() {
    if ($(this).is(':visible')) {
      $('.popup-subscription__close').focus();
    }
  });
});

// ---------------------------------------------------------------------------
// Screen-reader announcements (WCAG 4.1.3)
// A single polite live region, plus hooks on the cart AJAX endpoints and
// add-to-cart button state changes so dynamic updates are announced.
// ---------------------------------------------------------------------------
$(document).ready(function () {
  var $live = $('<div id="a11y-live" class="visually-hidden" role="status" aria-live="polite"></div>').appendTo('body');
  var liveTimer;

  window.a11yAnnounce = function (message) {
    clearTimeout(liveTimer);
    $live.text('');
    liveTimer = setTimeout(function () { $live.text(message); }, 100);
  };

  $(document).ajaxComplete(function (event, xhr, settings) {
    var url = settings && settings.url ? settings.url : '';
    if (url.indexOf('/cart/add') !== -1) {
      window.a11yAnnounce('Item added to cart');
    } else if (url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1) {
      window.a11yAnnounce('Cart updated');
    }
  });

  // Announce add-to-cart button state changes driven by CSS span-swaps
  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        var status = m.target.getAttribute('data-button-status');
        if (status === 'added') {
          window.a11yAnnounce('Item added to cart');
        } else if (status === 'sold-out') {
          window.a11yAnnounce('This product is sold out');
        }
      });
    });
    $('[data-button-status]').each(function () {
      observer.observe(this, { attributes: true, attributeFilter: ['data-button-status'] });
    });
  }
});

// ---------------------------------------------------------------------------
// Popup focus management (WCAG 2.4.3, 2.1.2)
// Remember the trigger, trap Tab inside the open popup, restore focus on close.
// ---------------------------------------------------------------------------
$(document).ready(function () {
  var lastTrigger = null;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  $(document).on('click', '.js-popup-button, [data-js-popup-button]', function () {
    lastTrigger = this;
  });

  $(document).on('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var $popup = $('.js-popup.active');
    if (!$popup.length) return;
    var $panel = $popup.find('[data-js-popup-name].show');
    var $scope = $panel.length ? $panel : $popup;
    var $focusables = $scope.find(FOCUSABLE).filter(':visible');
    if (!$focusables.length) return;
    var first = $focusables[0];
    var last = $focusables[$focusables.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === $popup[0])) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  // Restore focus to the trigger when the popup closes
  if (window.MutationObserver && $('.js-popup').length) {
    var wasActive = $('.js-popup').hasClass('active');
    var popupObserver = new MutationObserver(function () {
      var isActive = $('.js-popup').hasClass('active');
      if (wasActive && !isActive && lastTrigger && document.body.contains(lastTrigger)) {
        lastTrigger.focus();
      }
      wasActive = isActive;
    });
    $('.js-popup').each(function () {
      popupObserver.observe(this, { attributes: true, attributeFilter: ['class'] });
    });
  }
});

// ---------------------------------------------------------------------------
// Carousel autoplay controls (WCAG 2.2.2, 2.3.3)
// Adds a pause/play button to every autoplaying slick carousel, and stops
// autoplay and background videos entirely for users who prefer reduced motion.
// ---------------------------------------------------------------------------
$(window).on('load', function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  $('.slick-initialized').each(function () {
    var $slider = $(this);
    var autoplay;
    try {
      autoplay = $slider.slick('slickGetOption', 'autoplay');
    } catch (err) {
      return;
    }
    if (!autoplay) return;

    if (reduceMotion) {
      $slider.slick('slickSetOption', 'autoplay', false).slick('slickPause');
      return;
    }

    var $btn = $('<button type="button" class="btn-plain carousel-autoplay-toggle" aria-pressed="false" aria-label="Pause automatic slide rotation">&#10074;&#10074;</button>');
    var paused = false;
    $btn.on('click', function () {
      paused = !paused;
      if (paused) {
        $slider.slick('slickPause');
        $btn.attr({ 'aria-pressed': 'true', 'aria-label': 'Resume automatic slide rotation' }).html('&#9654;');
      } else {
        $slider.slick('slickPlay');
        $btn.attr({ 'aria-pressed': 'false', 'aria-label': 'Pause automatic slide rotation' }).html('&#10074;&#10074;');
      }
    });
    $slider.before($btn);
  });

  if (reduceMotion) {
    $('video[autoplay]').each(function () {
      this.pause();
    });
  }
});





